import * as React from "react";
import {
  ActivityFragment,
  GroupFragment,
  CompanyMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { timeAgoLabel } from "../../../utils/timeAgo";
import { BuildingIcon } from "../../icons";
import { Link } from "../../wombat-ui";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

interface GroupUpdatedActivityProps {
  activity: GroupUpdatedActivity;
}

type GroupUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: GroupFragment;
};

export function isGroupUpdatedActivity(
  q: ActivityFragment
): q is GroupUpdatedActivity {
  return q.key === "group.updated";
}

interface GroupUpdatedActivityProps {
  activity: GroupUpdatedActivity;
}

export const GroupUpdatedActivity: React.FC<GroupUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="groupUpdatedActivity"
      visual={<BuildingIcon iconClassName="w-10 h-10 text-accent-500" />}
    >
      <Span className="text-sm">
        {t("activity.labels.groupUpdated", {
          group: (
            <Link
              to={`/users?groupId=${activity.trackable.id}`}
              key={activity.id}
            >
              {t("activity.objects.group")}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
